import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material';
import { WsService } from '../../shared/services/ws.service';
import { OrderService } from '@app/shared/services/order.service';

@Component({
  selector: 'app-order-incress-time',
  templateUrl: './order-incress-time.component.html',
  styleUrls: ['./order-incress-time.component.scss']
})
export class OrderIncressTimeComponent implements OnInit, AfterViewInit {

  @Input() orderId: any;
  @Output() closeWindow = new EventEmitter<boolean>();
  @ViewChild('timeInput', { read: MatInput }) input: MatInput;
  time;

  constructor(private orders: OrderService) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.input.focus();
  }

  @HostListener('document:keyup', ['$event'])
  hotkeyUpHandler($event) {
    console.log($event.keyCode);
    switch ($event.keyCode) {
      case 13: {
        $event.preventDefault();
        if (this.time.length > 0 && this.time <= 30) {
          this.orders.extendOrder({
            'id': this.orderId,
            'value': this.time
          }).subscribe((res: any) =>
            res.error ? this.closeWindow.emit(res.error) : this.closeWindow.emit(true)
          )
        }
        break;
      }

      case 27: {
        $event.preventDefault();
        this.closeWindow.emit(true);
        break;
      }
    }
  }

  @HostListener('document:mouseup', ['$event'])
  mouseHandler($event) {
    if ($event.target.closest('taxi-order-update-time') === null) {
      this.closeWindow.emit(true);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/order-incress-time/order-incress-time.component.ts